// file: frontend/foundry/src/services/apiRoutes.js

export const API_BASE = '/v1';

// User routes
export const SESSION_STATUS_ENDPOINT = `${API_BASE}/user/session_status`;
export const FIREBASE_AUTH_ENDPOINT = `${API_BASE}/user/firebase_auth`;
export const USER_INFO_URL = `${API_BASE}/user/info`;
export const USER_LOGOUT_URL = `${API_BASE}/user/logout`;

// JupyterLab routes
export const JUPYTERLAB_SERVER_INFO_URL = `${API_BASE}/eks_jupyterlab/serverinfo`;
export const API_CREATE_VIRTUAL_DOC_URL = `${API_BASE}/eks_jupyterlab/create_virtual_doc`;
export const JUPYTERLAB_SERVER_URL_ENDPOINT = (serverName) => `${API_BASE}/eks_jupyterlab/url/${serverName}`;
export const JUPYTERLAB_DISASSOCIATE_URL = `${API_BASE}/eks_jupyterlab/disassociate`;

// Document routes
export const API_DOCUMENT_LIST_URL = `${API_BASE}/document/list`;
export const API_DOCUMENT_DELETE_URL = `${API_BASE}/document/rm`;
export const API_DOCUMENT_RENAME_URL = `${API_BASE}/document/rename`;
export const API_DOCUMENT_RUN_URL = `${API_BASE}/document/run`;
export const API_DOCUMENT_GET_URL = `${API_BASE}/document/get`;
export const API_GET_PRESIGNED_URL = `${API_BASE}/document/get_presigned_url`;
export const API_CONFIRM_UPLOAD_URL = `${API_BASE}/document/confirm_upload`;

// Project routes
export const API_PROJECT_CREATE_URL = `${API_BASE}/project/create`;
export const API_PROJECT_RM_URL = `${API_BASE}/project/rm`;
export const API_PROJECT_LIST_URL = `${API_BASE}/project/list`;
export const API_PROJECT_RENAME_URL = `${API_BASE}/project/rename`;
export const API_PROJECT_DETAIL_URL = `${API_BASE}/project/detail`;

// Knowledge base routes
export const API_KB_CREATE_URL = `${API_BASE}/phase_kb/create`;
export const API_KB_LIST_URL = `${API_BASE}/phase_kb/list`;

// Conversation routes
export const API_CONVERSATION_SET_URL = `${API_BASE}/conversation/set`; 
export const API_CONVERSATION_COMPLETION_URL = `${API_BASE}/conversation/completion`;
export const API_CONVERSATION_LIST_URL = `${API_BASE}/conversation/list`;
export const API_CONVERSATION_GET_URL = `${API_BASE}/conversation/get`;

// Dialog routes
export const DIALOG_SET_URL = `${API_BASE}/dialog/set`;
export const DIALOG_LIST_URL = `${API_BASE}/dialog/list`;
export const DIALOG_RM_URL = `${API_BASE}/dialog/rm`;
export const DIALOG_GET_URL = `${API_BASE}/dialog/get`;
